import React from 'react';
import OrderCustomizationPhotos from './OrderCustomizationPhotos';

const OrderCustomizationSummary=({item})=>{
  const options=item?.options && typeof item.options==='object'
    ? item.options
    : {};

  const entries=Object.entries(options).flatMap(([group,value])=>{
    const values=Array.isArray(value) ? value : [value];

    return values
      .filter(Boolean)
      .map((selection)=>({
        group,
        selection
      }));
  });

  const splitGroups=item?.customization_mode==='split'
    && Array.isArray(item.customization_groups)
    ? item.customization_groups
    : [];

  if (
    !entries.length
    && !item?.option_summary
    && !splitGroups.length
    && !item?.special_instructions
    && !item?.custom_photo_urls?.length
  ) {
    return null;
  }

  return (
    <div className="mt-3 rounded-xl border border-indigo-100 bg-indigo-50/60 px-3 py-3">
      <p className="text-[9px] font-black uppercase tracking-widest text-indigo-500">
        Customizations
      </p>

      {splitGroups.length>0 ? (
        <div className="mt-2 space-y-3">
          {splitGroups.map((group,index)=>{
            const groupEntries=Object.entries(group.selection || {})
              .flatMap(([groupName,value])=>{
                const values=Array.isArray(value) ? value : [value];

                return values
                  .filter(Boolean)
                  .map((selection)=>(
                    <li
                      key={`${groupName}-${selection}`}
                      className="text-xs font-bold text-slate-700"
                    >
                      <span className="text-slate-400">{groupName}:</span>{' '}
                      {selection}
                    </li>
                  ));
              });

            return (
              <div
                key={group.id || index}
                className="rounded-xl bg-white/70 p-3"
              >
                <p className="text-[10px] font-black uppercase tracking-widest text-indigo-500">
                  Group {index+1} · {group.quantity} item{group.quantity===1 ? '' : 's'}
                </p>

                {groupEntries.length>0 && (
                  <ul className="mt-2 space-y-1">
                    {groupEntries}
                  </ul>
                )}

                {group.special_instructions && (
                  <p className="mt-2 text-xs font-medium leading-relaxed text-slate-600">
                    <span className="font-black text-slate-400">Instructions:</span>{' '}
                    {group.special_instructions}
                  </p>
                )}

                <OrderCustomizationPhotos images={group.custom_photo_urls} />
              </div>
            );
          })}
        </div>
      ) : entries.length>0 ? (
        <ul className="mt-2 space-y-1">
          {entries.map(({group,selection})=>(
            <li
              key={`${group}-${selection}`}
              className="text-xs font-bold text-slate-700"
            >
              <span className="text-slate-400">{group}:</span>{' '}
              {selection}
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-2 text-xs font-bold text-slate-700">
          {item.option_summary}
        </p>
      )}

      {item?.special_instructions && splitGroups.length===0 && (
        <p className="mt-2 text-xs font-medium leading-relaxed text-slate-600">
          <span className="font-black text-slate-400">Instructions:</span>{' '}
          {item.special_instructions}
        </p>
      )}

      {splitGroups.length===0 && (
        <OrderCustomizationPhotos images={item?.custom_photo_urls} />
      )}

      {item?.option_adjustment !== undefined
        && item?.option_adjustment !== null ? (
        <p className="mt-2 text-[10px] font-black uppercase tracking-widest text-indigo-600">
          Option adjustments: {Number(item.option_adjustment)>0 ? '+' : ''}
          ${Math.abs(Number(item.option_adjustment)).toFixed(2)}
        </p>
      ) : null}
    </div>
  );
};

export default OrderCustomizationSummary;
